/// <amd-module name="Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressContracts" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";

/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefreshCloneContracts" />

/**
 * ITesPlanCloneProgres: This state contains global information for the clone progress operation. Only present if there is a opId in a query
 */
export interface ITestPlanCloneProgressAwareState extends ITestHubRefreshAwareState {
    testPlanCloneProgressState: ITestPlanCloneProgressState;
}

export interface ITestPlanCloneProgressState {
    opId: number; // opId with which the clone progress state will be checked
    timeElapsed: number; // indicator of how many times the polling occured before clone is complete
    state: CloneOperationState; // state of the clone operation
}

export const enum CloneOperationState {
    Failed = 2,
    InProgress = 1,
    Queued = 0,
    Succeeded = 3
}
